module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOBAMAAAC88gOBAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9kKFhYNCov3vzQAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAFVBMVEVwUPCAeHCQkKCY2NjQ+Oj4+Pj///9bEgJ8AAAAAXRSTlMAQObYZgAAAAFiS0dEBmFmuH0AAABdSURBVAjXY2BxQQEODM7GKMCEwRgNgARMQ4WNQQiIIQKGgcKmgoHGgYIwAeNAY1NhQSBpjCxgbBwaiCYQKIgiEIikBWiLYaggsi1A40EIYQuKw5RR+UYMTEooQAEAgkYr61eBz7EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/types/Ice.png
// module id = 168
// module chunks = 0